import React from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { classNames } from '@app/utils/classes'
import { Link } from '../typo/link'

const getCatCss = (cat: string, isLink?: boolean) => {
  if (cat === 'engineering') {
    const base =
      'bg-white dark:bg-gray-100 border border-2 border-green-800 text-green-700'

    return isLink
      ? classNames(
          base,
          'hover:border-green-500 hover:bg-green-500 dark:hover:border-green-500 dark:hover:bg-green-500 hover:text-white'
        )
      : base
  }
  if (cat === 'wcag' || cat === 'crawling') {
    const base =
      'bg-white dark:bg-gray-100  border border-2 border-indigo-800 text-indigo-700'

    return isLink
      ? classNames(
          base,
          'hover:border-indigo-500 hover:bg-indigo-500 dark:hover:border-indigo-500 dark:hover:bg-indigo-500 hover:text-white'
        )
      : base
  }
  if (cat === 'api') {
    const base =
      'bg-white dark:bg-gray-100 border border-2 border-orange-800 text-orange-700'

    return isLink
      ? classNames(
          base,
          'hover:border-orange-500 hover:bg-orange-500 dark:hover:border-orange-500 dark:hover:bg-orange-500 hover:text-white'
        )
      : base
  }
  if (cat === 'accessibility') {
    const base =
      'bg-white dark:bg-gray-100 border border-2 border-blue-800 text-blue-700'

    return isLink
      ? classNames(
          base,
          'hover:border-blue-500 hover:bg-blue-500 dark:hover:border-blue-500 dark:hover:bg-blue-500 hover:text-white'
        )
      : base
  }
}

const getCategoryTranslation = (cat: string) => {
  if (cat === 'engineering') {
    return 'categories.0'
  }
  if (cat === 'api') {
    return 'categories.1'
  }
  if (cat === 'accessibility') {
    return 'categories.2'
  }
  if (cat === 'wcag') {
    return 'categories.3'
  }
  if (cat === 'crawling') {
    return 'categories.0'
  }
  if (cat === 'platform') {
    return 'categories.3'
  }
  // TODO: handle guide category chips
  return 'categories.0'
}

const getCatRoute = (cat: string) => {
  if (cat === 'engineering') {
    return '/blog/categories/engineering'
  }
  if (cat === 'api') {
    return '/blog/categories/api'
  }
  if (cat === 'accessibility') {
    return '/blog/categories/accessibility'
  }
  if (cat === 'wcag') {
    return '/blog/categories/wcag'
  }
  return '/blog/categories/api'
}

export const Category = ({
  category,
  pure,
  translation,
}: {
  category: string
  pure?: boolean
  translation?: string
}) => {
  const { t } = useTranslation(translation ?? 'blog')
  const categoryWords = t(getCategoryTranslation(category))

  if (pure) {
    const catCss = classNames(
      getCatCss(category, true) || '',
      'rounded px-2 py-0.5 hover:no-underline md:text-xl font-bold'
    )

    if (['crawling', 'accessibility', 'platform'].includes(category)) {
      return (
        <span
          className={`rounded-xl bg-gray-300 text-black dark:bg-gray-800 dark:text-white px-2 py-1 text-xs uppercase`}
        >
          {categoryWords}
        </span>
      )
    }

    const catRoute = getCatRoute(category)

    return (
      <Link href={catRoute} className={catCss}>
        {categoryWords}
      </Link>
    )
  }

  return (
    <div
      className={classNames(
        getCatCss(category) || '',
        'absolute top-2 left-2 px-2 py-0.5 z-10 rounded uppercase font-bold md:text-lg'
      )}
    >
      {categoryWords}
    </div>
  )
}
